import { render, staticRenderFns } from "./Export.vue?vue&type=template&id=10048e96&scoped=true&"
import script from "./Export.vue?vue&type=script&lang=js&"
export * from "./Export.vue?vue&type=script&lang=js&"
import style0 from "./Export.vue?vue&type=style&index=0&id=10048e96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10048e96",
  null
  
)

export default component.exports